import axios from "axios";
import { getToken } from "../../../Utlis/UpdateUserState";

const getDriverDocumentRequirements = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=driver`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Driver document requirements fetch error:", error);
    throw error;
  }
};

const createDriverDocumentRequirement = async (data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=driver`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Driver document requirement create error:", error);
    throw error;
  }
};

const getDriverDocumentRequirementById = async (id) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=driver&id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Driver document requirement fetch error:", error);
    throw error;
  }
};

const updateDriverDocumentRequirement = async (id, data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=driver&id=${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Driver document requirement update error:", error);
    throw error;
  }
};

const deleteDriverDocumentRequirement = async (id) => {
  try {
    const token = getToken();

    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=driver&id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Driver document requirement delete error:", error);
    throw error;
  }
};

export {
  getDriverDocumentRequirements,
  createDriverDocumentRequirement,
  getDriverDocumentRequirementById,
  updateDriverDocumentRequirement,
  deleteDriverDocumentRequirement,
};
